import { render, staticRenderFns } from "./DadosEmail.vue?vue&type=template&id=73219ba2&"
import script from "./DadosEmail.vue?vue&type=script&lang=ts&"
export * from "./DadosEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports